const assetsUrl = document.querySelector("meta[name=assets-url]")?.content;
if (assetsUrl) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = assetsUrl;
}
